import { Radio } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

export const PreviewFrame = styled.div`
  background-image: url(${({ theme }) => theme.images.previewFrame});
  background-repeat: no-repeat;
  background-size: contain;
  height: 262px;
  position: relative;
  width: 60%;
`;

export const PreviewFrameSenderName = styled.span`
  font-size: 12px;
  font-weight: bold;
  left: 35px;
  line-height: 20px;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 25px;
  white-space: nowrap;
  width: 100px;
`;

export const PreviewFrameText = styled.span`
  font-size: 10px;
  left: 130px;
  line-height: 20px;
  max-width: 188px;
  outline: 1px solid var(--color-accent-primary-default);
  overflow: hidden;
  padding: 0 4px;
  position: absolute;
  text-overflow: ellipsis;
  top: 25px;
  white-space: nowrap;
  width: 256px;
`;

export const SelectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${Radio.S.InputBody} {
    align-items: start;
  }
`;

export const ShareTypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 120px;
  width: 100%;
`;

export const Wrapper = styled.div`
  border-radius: var(--size-border-radius-md);
`;
